/* eslint-disable function-paren-newline, no-confusing-arrow, react-hooks/exhaustive-deps, indent */
/* react/jsx-curly-newline, no-alert, consistent-return */
import React, { useEffect, useRef, useState } from 'react';

import truncate from 'lodash.truncate';
import { useDispatch } from 'react-redux';

import Dropdown from '../../components/Feedback/Dropdown/Dropdown';
import ErrorBox from '../../components/Feedback/ErrorBox/ErrorBox';
import ErrorPopup from '../../components/Feedback/ErrorPopup/ErrorPopup';
import SuccessPopup from '../../components/Feedback/SuccessPopup/SuccessPopup';

import { getIssues, getSubIssues, saveFeedback, uploadAttachment } from '../../redux/slices/feedbackSlice';

import DownArrow from '../../assets/images/DownArrow.svg';
import DownArrowMobile from '../../assets/images/DownArrowMobile.svg';
import FeedbackChatIcon from '../../assets/images/FeedbackChatIcon.svg';
import FeedbackChatIconMobile from '../../assets/images/FeedbackIconMobile.svg';
import UploadIcon from '../../assets/images/UploadIcon.svg';
import UploadIconMobile from '../../assets/images/UploadIconMobile.svg';

import { formStateUtil } from '../../utils/FeedbackUtil';

import styles from './Feedback.module.scss';

function FeedbackContainer() {
  const hiddenFileInput = useRef(null);
  const dispatch = useDispatch();
  const [fileUploaded, setFileUploaded] = useState('');
  const [dropdownState, setDropdownState] = useState({
    show: false,
    state: '',
  });

  const [errorState, setErrorState] = useState({
    type: '',
    error: '',
  });
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [key, setKey] = useState(false);
  const [active, setActive] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const [formState, setFormState] = useState(formStateUtil);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  // eslint-disable-next-line consistent-return
  const handleChange = async (event) => {
    setFileUploading(true);
    const fileSize = event.target.files[0].size;
    const fileMb = fileSize / 1024 ** 2;
    if (fileMb > 2) return alert('File cannot be greater than 2mb');
    const formData = new FormData();
    formData.append('attachment', event.target.files[0]);

    const mediaData = await dispatch(uploadAttachment(formData)).unwrap();
    setAttachmentUrl(mediaData);
    setFileUploading(false);

    setFileUploaded(event.target.files[0].name);
  };

  const handleRemoveFile = () => {
    setFileUploaded('');
    setAttachmentUrl('');
  };

  const handleDropDownClick = (state) => {
    setErrorState({ type: '', error: '' });
    setDropdownState({ show: !dropdownState?.show, state });
  };

  const handleItemClick = (id, name, type, index, flag = 0) => {
    setDropdownState({ show: false });
    if (type === 'product') {
      setFormState((prevState) => ({
        ...prevState,
        selectedProduct: { id, name },
      }));
    } else if (type === 'examCat') {
      setFormState((prevState) => ({
        ...prevState,
        selectedExamCat: { id, name },
      }));
    } else if (type === 'exam') {
      setFormState((prevState) => ({
        ...prevState,
        selectedExam: { id, name },
      }));
    } else if (type === 'issue') {
      setFormState((prevState) => ({
        ...prevState,
        selectedIssue: { id, name, flag },
      }));
    }
    setFormState((prevState) => ({
      ...prevState,
      subIssuesArray: formState?.subIssuesArray?.map((value, i) => (i === index ? id : value)),
    }));
  };

  const onDropdownItemChange = async (id, name, type, index, skipAllDropDowns = 0, flag = 0) => {
    handleItemClick(id, name, type, index, flag);
    let data = [];
    if (type !== 'issue') {
      data = await dispatch(getSubIssues(id)).unwrap();
    }
    if (type === 'product') {
      setFormState((prevState) => ({
        ...prevState,
        selectedExamCat: { id: 0, name: '' },
        selectedExam: { id: 0, name: '' },
        selectedIssue: { id: 0, name: '' },
      }));
      if (skipAllDropDowns === 1) {
        setKey(true);
        setFormState((prevState) => ({
          ...prevState,
          issuesData: data,
        }));
      } else {
        setKey(false);
        setFormState((prevState) => ({
          ...prevState,
          examCatData: data,
        }));
      }
    } else if (type === 'examCat') {
      setFormState((prevState) => ({
        ...prevState,
        selectedExam: { id: 0, name: '' },
        selectedIssue: { id: 0, name: '' },
      }));
      setFormState((prevState) => ({
        ...prevState,
        examData: data,
      }));
    } else if (type === 'exam') {
      setFormState((prevState) => ({
        ...prevState,
        selectedIssue: { id: 0, name: '' },
      }));
      setFormState((prevState) => ({
        ...prevState,
        issuesData: data,
      }));
    }
  };

  function isValidEmail(email) {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Test the email against the regular expression
    return emailRegex.test(email);
  }

  const handleErrors = () => {
    if (formState?.userName?.length <= 0) {
      setErrorState({ type: 'name', error: 'Please fill in this field' });
      return false;
    }
    if (formState?.mobile?.length <= 0) {
      setErrorState({ type: 'mobile', error: 'Please fill in this field' });
      return false;
    }
    if (formState?.mobile?.length > 0 && formState?.mobile?.length < 10) {
      setErrorState({
        type: 'mobile',
        error: `Please lengthen this text to 10 characters or more 
        (you are currently ${formState?.mobile?.length} characters).`,
      });
      return false;
    }
    if (formState?.email?.length <= 0) {
      setErrorState({ type: 'email', error: 'Please fill in this field' });
      return false;
    }
    if (formState?.email?.length > 0 && !formState?.email?.includes('@')) {
      setErrorState({
        type: 'email',
        error: `Please include an ‘@’ in the email address. ${formState?.email} is missing an ‘@’.`,
      });
      return false;
    }
    if (formState?.email?.length > 0 && !isValidEmail(formState?.email)) {
      setErrorState({
        type: 'email',
        error: 'Please enter valid email',
      });
      return false;
    }
    if (formState?.selectedProduct?.name?.length <= 0) {
      setErrorState({
        type: 'product',
        error: 'Please select an item from the list.',
      });
      return false;
    }
    if (!key) {
      if (formState?.selectedExamCat?.name?.length <= 0) {
        setErrorState({
          type: 'examCat',
          error: 'Please select an item from the list.',
        });
        return false;
      }
      if (formState?.selectedExam?.name?.length <= 0) {
        setErrorState({
          type: 'exam',
          error: 'Please select an item from the list.',
        });
        return false;
      }
    }
    if (formState?.selectedIssue?.name?.length <= 0) {
      setErrorState({
        type: 'issues',
        error: 'Please select an item from the list.',
      });
      return false;
    }
    if (formState?.text?.length <= 0) {
      setErrorState({
        type: 'text',
        error: 'Please fill in this field.',
      });
      return false;
    }
    if (formState?.text?.length < 30) {
      setErrorState({
        type: 'text',
        error: 'Please enter at least 30 characters',
      });
      return false;
    }

    return true;
  };

  const fetchProductData = async () => {
    const data = await dispatch(getIssues()).unwrap();
    setFormState((prevState) => ({
      ...prevState,
      productData: data,
    }));
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  const onSubmit = async () => {
    const attachmentPresent = attachmentUrl || null;
    const payload = {
      attachmentUrl: attachmentPresent,
      // contentId: 100059,
      contentType: 10,
      // courseId: 1362,
      customFeedback: formState?.text,
      email: formState?.email,
      feedbackSectionId: 1,
      // languageId: 1,
      name: formState?.userName,
      phoneNumber: formState?.mobile,
      productType: 1,
      reactionType: 2,
      subIssues: formState?.subIssuesArray,
    };

    const noError = handleErrors();

    if (noError) {
      const result = await dispatch(saveFeedback(payload)).unwrap();
      if (result?.success === 1) {
        setShowSuccessPopup(true);
      } else {
        setShowErrorPopup(true);
      }
    }
  };

  const onSuccessClose = () => {
    setShowSuccessPopup(false);
    setFormState((prevState) => ({
      ...prevState,
      selectedProduct: { id: 0, name: '' },
      selectedExamCat: { id: 0, name: '' },
      selectedExam: { id: 0, name: '' },
      selectedIssue: { id: 0, name: '' },
      text: '',
      subIssuesArray: [0, 0, 0, 0],
      productData: [],
      examCatData: [],
      examData: [],
      issuesData: [],
    }));
    setActive(false);
    setFileUploaded('');
    setAttachmentUrl('');
    fetchProductData();
  };

  const validatePhoneInput = (event) => {
    if (/[0-9]+/.test(event.key) === false && event.which !== 8 && event.key.length === 1) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (formState?.selectedIssue?.flag === 1) {
      setPopupMsg(
        'Our support team will respond you on your registered email address shortly!');
    } else if (formState?.selectedIssue?.flag === 2) {
      setPopupMsg(
        'Our counsellor team will respond you on your registered details!');
    }
  }, [formState?.selectedIssue]);

  return (
    <div>
      <div className={styles.feedbackContainer}>
        <div className={styles.feedbackHeaderWrapper}>
          <div className={styles.feedbackIcon}>
            <FeedbackChatIcon />
          </div>
          <div className={styles.feedbackIconMobile}>
            <FeedbackChatIconMobile />
          </div>
          <div className={styles.headingWrapper}>
            <div className={styles.heading}>Need Help?</div>
            <div className={styles.subHeading}>
              Don’t worry, just ask and we’ll find the best solution for all your queries.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.formWrapper}>
        <div className={styles.formHeaderWrapper}>
          <div className={styles.formHeading}>Service Related</div>
        </div>
        <div className={styles.formContent}>
          <div className={styles.primaryDetails}>
            <div className={styles.inputWrapper}>
              <input
                placeholder="Your Name"
                className={errorState?.type === 'name' && errorState?.error.length > 0 ? styles.errorState : null}
                onChange={(e) => {
                  setFormState((prevState) => ({
                    ...prevState,
                    userName: e.target.value,
                  }));
                  setErrorState({ type: '', error: '' });
                }}
                value={formState?.userName}
              />
              {errorState?.type === 'name' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
            <div className={styles.inputWrapper}>
              <input
                placeholder="Mobile"
                type="text"
                maxLength="10"
                onKeyDown={validatePhoneInput}
                className={errorState?.type === 'mobile' && errorState?.error.length > 0 ? styles.errorState : null}
                onChange={(e) => {
                  setFormState((prevState) => ({
                    ...prevState,
                    mobile: e.target.value,
                  }));
                  setErrorState({ type: '', error: '' });
                }}
                value={formState?.mobile}
              />
              {errorState?.type === 'mobile' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
            <div className={styles.inputWrapper}>
              <input
                placeholder="Email"
                className={errorState?.type === 'email' && errorState?.error.length > 0 ? styles.errorState : null}
                onChange={(e) => {
                  setFormState((prevState) => ({
                    ...prevState,
                    email: e.target.value,
                  }));
                  setErrorState({ type: '', error: '' });
                }}
                value={formState?.email}
              />
              {errorState?.type === 'email' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
          </div>
          <div className={styles.productDetails}>
            <div className={styles.dropdownContainer}>
              <div
                onClick={() => handleDropDownClick('product')}
                className={`${styles.dropdownWrapper} ${
                  errorState?.type === 'product' && errorState?.error.length > 0 && styles.errorState
                }`}
              >
                <div className={styles.dropdownHeading}>
                  {formState?.selectedProduct?.name
                    ? `${truncate(formState?.selectedProduct?.name, {
                        length: 20,
                        omission: '...',
                      })}`
                    : 'Select Product'}
                </div>
                <div className={styles.downArrowIcon}>
                  <DownArrow />
                </div>
                <div className={styles.downArrowIconMobile}>
                  <DownArrowMobile />
                </div>
              </div>
              {dropdownState?.show && dropdownState?.state === 'product' && (
                <div className={styles.dropDown}>
                  <Dropdown
                    selectedItem={formState?.selectedProduct}
                    handleItemClick={(id, name, skipAllDropDowns) => {
                      onDropdownItemChange(id, name, 'product', 0, skipAllDropDowns);
                    }}
                    data={formState?.productData}
                  />
                </div>
              )}
              {errorState?.type === 'product' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
            <div className={`${styles.dropdownContainer} ${key && styles.dropdownDisabled}`}>
              <div
                className={`${styles.dropdownWrapper} ${
                  errorState?.type === 'examCat' && errorState?.error.length > 0 && styles.errorState
                }`}
                onClick={!key && (() => handleDropDownClick('examCat'))}
              >
                <div className={styles.dropdownHeading}>
                  {formState?.selectedExamCat?.name !== '' ? formState?.selectedExamCat?.name : 'Select Exam Category'}
                </div>
                <div className={styles.downArrowIcon}>
                  <DownArrow />
                </div>
                <div className={styles.downArrowIconMobile}>
                  <DownArrowMobile />
                </div>
              </div>
              {dropdownState?.show && dropdownState?.state === 'examCat' && (
                <div className={styles.dropDown}>
                  <Dropdown
                    selectedItem={formState?.selectedExamCat}
                    handleItemClick={(id, name) => {
                      onDropdownItemChange(id, name, 'examCat', 1);
                    }}
                    data={formState?.examCatData}
                  />
                </div>
              )}
              {errorState?.type === 'examCat' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
            <div className={`${styles.dropdownContainer} ${key && styles.dropdownDisabled}`}>
              <div
                className={`${styles.dropdownWrapper} ${
                  errorState?.type === 'exam' && errorState?.error.length > 0 && styles.errorState
                }`}
                onClick={!key && (() => handleDropDownClick('exam'))}
              >
                <div className={styles.dropdownHeading}>
                  {formState?.selectedExam?.name !== '' ? formState?.selectedExam?.name : 'Select Exam'}
                </div>
                <div className={styles.downArrowIcon}>
                  <DownArrow />
                </div>
                <div className={styles.downArrowIconMobile}>
                  <DownArrowMobile />
                </div>
              </div>
              {dropdownState?.show && dropdownState?.state === 'exam' && (
                <div className={styles.dropDown}>
                  <Dropdown
                    selectedItem={formState?.selectedExam}
                    handleItemClick={(id, name) => {
                      onDropdownItemChange(id, name, 'exam', 2);
                    }}
                    data={formState?.examData}
                  />
                </div>
              )}
              {errorState?.type === 'exam' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
            <div className={styles.dropdownContainer}>
              <div
                className={`${styles.dropdownWrapper} ${
                  errorState?.type === 'issues' && errorState?.error.length > 0 && styles.errorState
                }`}
                onClick={() => handleDropDownClick('issue')}
              >
                <div className={styles.dropdownHeading}>
                  {formState?.selectedIssue?.name !== ''
                    ? `${truncate(formState?.selectedIssue?.name, {
                        length: 20,
                        omission: '...',
                      })}`
                    : 'Select Issue'}
                </div>
                <div className={styles.downArrowIcon}>
                  <DownArrow />
                </div>
                <div className={styles.downArrowIconMobile}>
                  <DownArrowMobile />
                </div>
              </div>
              {dropdownState?.show && dropdownState?.state === 'issue' && (
                <div className={styles.dropDown}>
                  <Dropdown
                    selectedItem={formState?.selectedIssue}
                    handleItemClick={(id, name, skipAllDropDowns, supportSystemId) => {
                      onDropdownItemChange(id, name, 'issue', 3, skipAllDropDowns, supportSystemId);
                    }}
                    data={formState?.issuesData}
                  />
                </div>
              )}
              {errorState?.type === 'issues' && errorState?.error?.length > 0 && (
                <div className={styles.error}>
                  <ErrorBox message={errorState?.error} />
                </div>
              )}
            </div>
          </div>
          <div className={styles.concernWrapper}>
            <textarea
              placeholder="Describe Your Concern"
              className={errorState?.type === 'text' && errorState?.error.length > 0 ? styles.errorState : null}
              onChange={(e) => {
                setFormState((prevState) => ({
                  ...prevState,
                  text: e.target.value,
                }));
                if (formState?.text?.length > 30) {
                  setActive(true);
                }
                setErrorState({ type: '', error: '' });
              }}
              value={formState?.text}
            />
            {errorState?.type === 'text' && errorState?.error?.length > 0 && (
              <div className={styles.error}>
                <ErrorBox message={errorState?.error} />
              </div>
            )}
          </div>
          <div className={styles.filesUploadWrapper}>
            <div className={styles.filesUpload} onClick={handleClick}>
              <div className={styles.uploadIcon}>
                <UploadIcon />
              </div>
              <div className={styles.uploadIconMobile}>
                <UploadIconMobile />
              </div>
              <div className={styles.uploadText}>Upload file</div>
            </div>
            {fileUploaded?.length > 0 && (
              <div className={styles.fileWrapper}>
                <div className={styles.fileName}>
                  {`${truncate(fileUploaded?.split('.')[0], {
                    length: 20,
                    omission: '...',
                  })}`}
                  {`.${fileUploaded?.split('.')[1]}`}
                </div>
                <div className={styles.removeBtn} onClick={handleRemoveFile}>
                  Remove
                </div>
              </div>
            )}
          </div>
          <input
            type="file"
            ref={hiddenFileInput}
            accept="image/*"
            onChange={handleChange}
            style={{ display: 'none' }}
            onClick={(event) => {
              event.target.value = '';
            }}
            multiple
          />
        </div>
      </div>
      <div className={active && !fileUploading ? styles.submitBtnActive : styles.submitBtn}>
        <button type="submit" onClick={onSubmit}>
          Submit
        </button>
      </div>
      <div>
        <SuccessPopup show={showSuccessPopup} popupMsg={popupMsg} closePopup={onSuccessClose} />
      </div>
      <div>
        <ErrorPopup show={showErrorPopup} closePopup={() => setShowErrorPopup(false)} />
      </div>
    </div>
  );
}

export default FeedbackContainer;
